const videoLightBoxOpenButtons = document.querySelectorAll('.open-video-lightbox');

for (let openButton of videoLightBoxOpenButtons) {
    const parentPanel = openButton.closest('section');
    const lightbox = parentPanel.querySelector('.video-lightbox');

    if (lightbox) {
        const closeButton = lightbox.querySelector('button');

        lightbox.addEventListener('click', function(event) {
            var rect = lightbox.getBoundingClientRect();
            var isInDialog = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height &&
                rect.left <= event.clientX && event.clientX <= rect.left + rect.width);
            if (!isInDialog) {
                closeLightBox();
            }
        });

        function openLightBox() {
            lightbox.showModal();
            lightbox.classList.remove('opacity-0');
        }

        function closeLightBox() {
            lightbox.classList.add('opacity-0');
            lightbox.close();

            const iframe = lightbox.querySelector('iframe');
            const newFrame = iframe.cloneNode();
            newFrame.src = newFrame.dataset.src;
            iframe.replaceWith(newFrame);
        }

        document.addEventListener("keydown", (e) => {
            if (!lightbox.classList.contains('hidden')) {
                if (e.key === "Escape") {
                    closeLightBox();
                }
            }
        });

        openButton.addEventListener('click', () => {
            openLightBox();
        });

        closeButton.addEventListener('click', () => {
            closeLightBox();
        });
    }
}

